import DV from 'ts-data-validator';

/**
 * @param {{
 *   common: {
 *     regions: Array<number>,
 *     cities: Array<number>,
 *   }
 * }} offer
 * @param {{
 *   regionId: number,
 *   cityId: number,
 * }} currentCity
 * @return {boolean}
 */
export default function checkAccessOffer(offer = {}, currentCity = {}) {
  if (!DV.isNotEmptyObject(currentCity) || !DV.isNotEmptyObject(offer)) {
    return true;
  }

  const {
          common: {
                    regions      = [],
                    cities       = [],
                    notAvailable = false,
                  },
        } = offer;

  let result = true;

  if (notAvailable) {
    return false;
  }

  if (DV.isNotEmptyArray(regions)) {
    result = regions.includes(currentCity.regionId);
  }

  if (DV.isNotEmptyArray(cities)) {
    result = cities.includes(currentCity.cityId);
  }

  return result;
}